import useCSVHandler from "./useCSVHandler";

import { useTournamentRegistrationsContext } from "../contexts/TournamentRegistrations";
import { CSVData } from "../types/tournamentregistrations";

const useDownloadHandler = () => {
    const { orders, setFetchStatus } = useTournamentRegistrationsContext();
    const { generateCSVRow } = useCSVHandler();

    const handleDownload = async (
        setCSVData: React.Dispatch<React.SetStateAction<CSVData[]>>,
    ) => {
        setFetchStatus("pending");
        const filteredData = orders
            .flatMap(o => o.products.map(p => generateCSVRow(o, p)))
            .filter((data): data is CSVData => data !== null);

        setCSVData(filteredData);
        setFetchStatus(undefined);
    };

    return { handleDownload };
};

export default useDownloadHandler;
